"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
require("../../src/modules/singlestocktop/web");
var utils_1 = __importDefault(require("../../src/modules/commonutil/utils"));
var datatable_1 = __importDefault(require("../../src/modules/datatable"));
var public_1 = require("./public");
var delayquote_1 = require("../../src/modules/delayquote");
var webconfig = require('../../config/web');
var ggcgbd = {
    init: function () {
        var that = this;
        this.chart_bar = echarts.init(document.getElementById('cgbd_chart'));
        this.getData(); //画图
        var paramobj = {
            reportName: 'RPTA_WEB_GGMX',
            columns: 'ALL',
            token: '28dfeb41d35cc81d84b4664d7c23c49f',
            pageNumber: 1,
            pageNo: 1,
            pageSize: 50,
            sortColumns: 'TDATE',
            sortTypes: -1,
            quoteColumns: 'f2,f3',
            quoteType: delayquote_1.hsaDelay() ? "1" : "0",
            filter: "(SCODE=\"" + stockInfo.code + "\")"
        };
        this.loadTable(paramobj); //变动明细表
        $('#type_radio input').change(function () {
            var data_type = $(this).data('type') || '';
            that.getData(data_type);
        });
        $("#zj_type_ul li").click(function () {
            $("#zj_type_ul li").removeClass('at');
            $(this).addClass('at');
            var zj_type = $(this).attr('data');
            paramobj.pageNumber = 1;
            paramobj.pageNo = 1;
            paramobj.filter = "(SCODE=\"" + stockInfo.code + "\")" + zj_type;
            that.table.search(paramobj);
        });
    },
    getData: function (data_type) {
        return __awaiter(this, void 0, void 0, function () {
            var that, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        data_type = data_type || 'BDJE';
                        that.XData = [];
                        that.YData = [];
                        params = {
                            reportName: 'RPTA_WEB_GGGGTJ',
                            columns: 'ALL',
                            token: '28dfeb41d35cc81d84b4664d7c23c49f',
                            pageNumber: 1,
                            pageSize: 500,
                            sortColumns: 'TDATE',
                            sortTypes: 1,
                            filter: "(SCODE=\"" + stockInfo.code + "\")"
                        };
                        return [4 /*yield*/, $.ajax({
                                url: webconfig.getWebPath('datacenter') + "api/data/v1/get",
                                dataType: "jsonp",
                                data: params
                            }).then(function (data) {
                                that.chart_bar.showLoading({
                                    text: '图表加载中...' //loading
                                });
                                if (data.result && data.result.data) {
                                    var chartData = data.result.data;
                                    var data1 = [], data2 = [];
                                    for (var i = 0; i < chartData.length; i++) {
                                        var item = chartData[i];
                                        if (data_type == "BDJE") {
                                            data1.push(utils_1["default"].toFixed2(Math.abs(public_1.GetRealvalue(item.ZCJE, item.zcje)) / 10000 || '')); //为0时置空
                                            data2.push(utils_1["default"].toFixed2(Math.abs(public_1.GetRealvalue(item.JCJE, item.jcje)) / 10000 || ''));
                                        }
                                        else {
                                            data1.push(utils_1["default"].toFixed2(Math.abs(public_1.GetRealvalue(item.ZCSL, item.zcsl)) / 10000 || ''));
                                            data2.push(utils_1["default"].toFixed2(Math.abs(public_1.GetRealvalue(item.JCSL, item.jcsl)) / 10000 || ''));
                                        }
                                        that.XData.push(utils_1["default"].dateFormat(public_1.GetRealvalue(item.TDATE, item.TDATE), "YYYY-MM"));
                                    }
                                    that.YData.push(data1);
                                    that.YData.push(data2);
                                }
                                that.loadChart();
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    loadChart: function () {
        var that = this;
        var dw_name = $('#type_radio input:checked').next("label").data("name") || '元';
        // 指定图表的配置项和数据
        var option = {
            tooltip: {
                trigger: 'axis'
            },
            legend: {
            //data: ['销量']
            },
            xAxis: {
                data: that.XData,
                axisTick: { show: false },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    textStyle: {
                        color: '#000'
                    }
                }
            },
            yAxis: {
                name: '单位：' + dw_name,
                axisTick: { show: false },
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: 'dotted',
                        color: "#E6E6E6"
                    }
                },
                axisLabel: {
                    textStyle: {
                        color: '#000'
                    }
                    //formatter: function (value, index) {
                    //    return Tools.toFixed(value / 10000);
                    //}
                }
            },
            series: [{
                    name: "增持",
                    type: 'bar',
                    barGap: 0,
                    color: '#d32f2f',
                    barMaxWidth: '30',
                    barMinHeight: 1,
                    data: that.YData[0]
                },
                {
                    name: "减持",
                    type: 'bar',
                    color: '#4caf50',
                    barMaxWidth: '30',
                    barMinHeight: 1,
                    data: that.YData[1]
                }]
        };
        // 使用刚指定的配置项和数据显示图表。
        that.chart_bar.setOption(option);
        that.chart_bar.hideLoading();
    },
    loadTable: function (paramobj) {
        var that = this;
        that.table = new datatable_1["default"]({
            table_type: 'bdmx_default',
            div_id: 'bdmx_table',
            pager_id: 'bdmx_table_pager',
            enabled_pager: true,
            floathead: true,
            loadscroll: true,
            loadingImg: true,
            dataurl: {
                hostname: 'datacenter',
                url: 'api/data/v1/get',
                params: paramobj
            },
            columns: {
                config: [
                    {
                        width: 70,
                        paramname: '',
                        th: function name(v) {
                            return '日期';
                        },
                        td: function (v) {
                            return utils_1["default"].dateFormat(v.TDATE);
                        }
                    },
                    {
                        width: 40,
                        paramname: '',
                        th: function name(v) {
                            return '相关';
                        },
                        td: function (v) {
                            var notice_url = "/notices/stock/" + v.SCODE + ".html";
                            return '<a href=' + notice_url + '>公告</a>'; //相关
                        }
                    },
                    {
                        // width: 70,
                        paramname: '',
                        th: function name(v) {
                            return '变动人';
                        },
                        td: function (v) {
                            return '<a href="/executive/personinfo.html?name=' + encodeURIComponent(v.BDR) + '&code=' + v.SCODE + '">' + utils_1["default"].txtLeft(v.BDR, 8, true) + '</a>'; //变动人
                        }
                    },
                    {
                        width: 52,
                        paramname: '',
                        th: function name(v) {
                            return '变动方向';
                        },
                        td: function (v) {
                            return '<span class="' + (v.BDFX == "增持" ? "red" : "green") + '">' + utils_1["default"].getTextValOrEmpty(v.BDFX) + '<span>'; //变动方向;
                        }
                    },
                    {
                        width: 55,
                        paramname: '',
                        th: function name(v) {
                            return '变动股数<br />（股）';
                        },
                        td: function (v) {
                            return utils_1["default"].numFormat(v.BDGS);
                        }
                    },
                    {
                        width: 40,
                        paramname: '',
                        th: function name(v) {
                            return '成交<br/>均价';
                        },
                        td: function (v) {
                            return utils_1["default"].toFixed2(v.CJJJ);
                        }
                    },
                    {
                        width: 40,
                        paramname: '',
                        th: function name(v) {
                            return '当日收<br />盘价';
                        },
                        td: function (v) {
                            return '<span class="' + utils_1["default"].getColor(v.CHG) + '">' + utils_1["default"].toFixed2(v.SPJ) + '</span>'; //当日收盘价
                        }
                    },
                    {
                        width: 53,
                        paramname: '',
                        th: function name(v) {
                            return '变动金额<br />(元)';
                        },
                        td: function (v) {
                            return utils_1["default"].numFormat(v.BDJE); //变动金额
                        }
                    },
                    {
                        width: 75,
                        paramname: '',
                        th: function name(v) {
                            return '变动原因';
                        },
                        td: function (v) {
                            return utils_1["default"].getTextValOrEmpty(v.BDYY);
                        }
                    },
                    {
                        // width: 57,
                        paramname: '',
                        th: function name(v) {
                            return '变动比例<br />(‰)';
                        },
                        td: function (v) {
                            return utils_1["default"].getTextValOrEmpty(v.BDBL) !== '-' ? utils_1["default"].toFixed2(v.BDBL, 4) : utils_1["default"].toFixed2(v.BDBL_1, 4);
                        }
                    },
                    {
                        // width: 80,
                        paramname: '',
                        th: function name(v) {
                            return '变动后<br />持股数（股）';
                        },
                        td: function (v) {
                            return utils_1["default"].numFormat(v.BDHCG);
                        }
                    },
                    {
                        width: 30,
                        paramname: '',
                        th: function name(v) {
                            return '持股<br />种类';
                        },
                        td: function (v) {
                            return 'A股';
                        }
                    },
                    {
                        width: 53,
                        paramname: '',
                        th: function name(v) {
                            return '董监高<br />人员姓名';
                        },
                        td: function (v) {
                            return utils_1["default"].getTextValOrEmpty(v.GGXM);
                        }
                    },
                    {
                        width: 75,
                        paramname: '',
                        th: function name(v) {
                            return '职务';
                        },
                        td: function (v) {
                            return utils_1["default"].getTextValOrEmpty(v.ZW);
                        }
                    },
                    {
                        width: 60,
                        paramname: '',
                        th: function name(v) {
                            return '变动人与董<br />监高的关系';
                        },
                        td: function (v) {
                            return utils_1["default"].getTextValOrEmpty(v.GX);
                        }
                    }
                ]
            }
        });
    }
};
$(function () {
    ggcgbd.init();
});
